import { mlvLogoAppBarCenter } from '../../../core/brand/mlvLogo.js';
import { buildWhatsAppUrl } from '../../../core/contact/whatsappLink.js';
import {
  buildMapsCategoria,
  CATEGORIAS_PRODUCTO,
  getChipsCatalogoHome,
} from '../../../core/catalog/categoriasProducto.js';
import { PRECIO_MAX_ARS } from '../../../core/catalog/precioLimites.js';
import { openGuestAuthModal } from '../../../core/ui/guestAuthModal.js';
import { buildMlvProductPublicUrl } from '../../../core/navigation/mlvPublicUrl.js';
import {
  htmlBadgeEstrellasReputacion,
  htmlFilaEstrellasReputacionDetalle,
} from '../../../core/ui/reputacionStarsHtml.js';
import { escapeHtml as esc } from '../../../core/ui/escapeHtml.js';
import { slotsPublicidadHomeDesdeDoc } from '../domain/publicidadHomeRules.js';
import {
  filtrarProductosCatalogo,
  hayFiltrosCatalogoActivos,
  normalizarTextoBusquedaCatalogo,
  ordenarMinMaxFiltroPrecio,
  parsePrecioFiltroEnteroCatalogo,
} from '../domain/catalogoFiltrosRules.js';
import { pintarBloquesPublicidadHome } from './catalogoHomePublicidadUi.js';
import { mlvNavPng, mlvPng } from '../../../core/ui/mlvPngIcons.js';
import { isServiciosNavVisible } from '../../../core/config/mlvFeatureFlags.js';
import { mlvTrack } from '../../../core/telemetry/mlvTrack.js';
import { MLV_EVENTS } from '../../../core/telemetry/mlvEvents.js';
import { openAdminEliminarPublicacionModal } from '../../../core/ui/adminEliminarPublicacionModal.js';
import { runCompletarVentaFlow } from '../../vendedor/presenter/completarVentaUi.js';
import { withBusyButton } from '../../../core/ui/withBusyButton.js';
import {
  asegurarClaimAdminParaAccion,
  resolverEsAdminSesion,
} from '../../../core/security/mlvAdminUi.js';

const { ETIQUETA_CATEGORIA, ETIQUETA_CATEGORIA_CARD } = buildMapsCategoria();
const CHIPS_CATEGORIA = getChipsCatalogoHome();

const PRECIO_MAX_FILTRO_ARS = PRECIO_MAX_ARS;

function formatPrecioAr(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return '—';
  return x.toLocaleString('es-AR', { maximumFractionDigits: 0 });
}

function iconSearchCat() {
  return `<svg class="w-5 h-5 text-slate-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" /></svg>`;
}

function iconBellCat() {
  return `<svg class="h-6 w-6 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" /></svg>`;
}

function iconFilterCat() {
  return mlvPng('menu', 'h-6 w-6 object-contain brightness-0 invert', { w: 24, h: 24 });
}

function iconNavHomeCat() {
  return mlvNavPng('home');
}

function iconNavPlusCat(active) {
  const c = active ? 'text-brand-primary' : 'text-slate-500';
  return `<svg class="h-6 w-6 ${c}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9" /><path stroke-linecap="round" stroke-linejoin="round" d="M12 8.25v7.5M8.25 12h7.5" /></svg>`;
}

function iconNavPersonCat() {
  return mlvNavPng('profile');
}

function iconNavServiciosCat() {
  return mlvNavPng('servicios');
}

function iconBackOnImageDet() {
  return `<svg class="h-5 w-5 text-slate-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>`;
}

function iconBackHeaderTealDet() {
  return `<svg class="h-5 w-5 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>`;
}

function iconSparkleSoldDet() {
  return `<svg class="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" /></svg>`;
}

/** Copy + CTAs cuando la publicación ya se vendió (vitrina o no). */
function htmlVendidoUpsellBlock({ premiumBtnId = '', catalogBtnId, footnote = '' }) {
  const premiumBtn = premiumBtnId
    ? `<button type="button" id="${premiumBtnId}" class="w-full rounded-full bg-brand-primary py-3.5 text-sm font-bold text-white shadow-md transition hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2">Ver plan Premium</button>`
    : '';
  return `
                <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-primary/10 text-brand-primary">
                  ${iconSparkleSoldDet()}
                </div>
                <h3 class="text-center font-heading text-xl font-bold leading-snug text-slate-900">Esta publicación ya se vendió</h3>
                <p class="mt-3 text-center text-sm leading-relaxed text-slate-600">
                  Lo que buscabas ya encontró dueño en el barrio: el marketplace mueve. No es un error tuyo ni del link.
                </p>
                <p class="mt-3 text-center text-sm leading-relaxed text-slate-600">
                  Seguí explorando otras publicaciones. <strong class="font-semibold text-slate-800">Si vos también vendés</strong>, el plan Premium suma cupos y visibilidad para que te encuentren antes.
                </p>
                <div class="mt-6 flex flex-col gap-2.5">
                  ${premiumBtn}
                  <button type="button" id="${catalogBtnId}" class="w-full rounded-full border-2 border-slate-200 bg-white py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-brand-primary/25">Explorar el catálogo</button>
                </div>
                ${footnote}`;
}

function iconStoreSellerDet() {
  return mlvPng('shop', 'h-6 w-6 object-contain brightness-0 invert', { w: 24, h: 24 });
}

function iconVerifiedBadgeDet() {
  return `<svg class="h-6 w-6 text-brand-secondary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>`;
}

function iconChatWaDet() {
  return mlvPng('whatsapp', 'h-7 w-7 shrink-0 object-contain', { w: 28, h: 28 });
}

/** @param {string | string[]} urlOrList una URL o lista; @param {number} [startIndex] */
function openImageFullscreen(urlOrList, startIndex = 0) {
  const list = Array.isArray(urlOrList)
    ? urlOrList.map((u) => String(u || '').trim()).filter(Boolean)
    : [String(urlOrList || '').trim()].filter(Boolean);
  if (!list.length) return;
  let idx = Math.max(0, Math.min(Number(startIndex) || 0, list.length - 1));
  const src = list[idx];
  document.getElementById('mlv-image-fullscreen')?.remove();
  const wrap = document.createElement('div');
  wrap.id = 'mlv-image-fullscreen';
  wrap.style.position = 'fixed';
  wrap.style.inset = '0';
  wrap.style.zIndex = '9999';
  wrap.style.background = 'rgba(0,0,0,0.94)';
  wrap.style.display = 'flex';
  wrap.style.alignItems = 'center';
  wrap.style.justifyContent = 'center';
  wrap.style.padding = '8px';
  const navVisible = list.length > 1 ? 'flex' : 'none';
  wrap.innerHTML = `
    <button type="button" id="mlv-fs-close" aria-label="Cerrar imagen" style="position:absolute;right:12px;top:12px;background:rgba(255,255,255,.95);border:none;border-radius:999px;padding:10px;box-shadow:0 2px 10px rgba(0,0,0,.25);z-index:3;">
      <svg style="width:20px;height:20px;color:#0f172a" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
    </button>
    <button type="button" id="mlv-fs-prev" aria-label="Foto anterior" style="display:${navVisible};position:absolute;left:8px;top:50%;transform:translateY(-50%);align-items:center;justify-content:center;width:44px;height:44px;background:rgba(255,255,255,.92);border:none;border-radius:999px;box-shadow:0 2px 10px rgba(0,0,0,.25);z-index:3;font-size:22px;font-weight:700;color:#0f172a;">‹</button>
    <button type="button" id="mlv-fs-next" aria-label="Foto siguiente" style="display:${navVisible};position:absolute;right:12px;top:50%;transform:translateY(-50%);align-items:center;justify-content:center;width:44px;height:44px;background:rgba(255,255,255,.92);border:none;border-radius:999px;box-shadow:0 2px 10px rgba(0,0,0,.25);z-index:3;font-size:22px;font-weight:700;color:#0f172a;">›</button>
    <div id="mlv-fs-stage" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;touch-action:none;">
      <img id="mlv-fs-img" src="${esc(src)}" alt="" style="max-width:96vw;max-height:96vh;object-fit:contain;transform:translate(0px,0px) scale(1);transform-origin:center center;will-change:transform;user-select:none;-webkit-user-drag:none;" />
    </div>
  `;
  const prevOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  const fsStateMarker = { __mlvImageFullscreen: true };
  let closed = false;

  const stage = wrap.querySelector('#mlv-fs-stage');
  const img = wrap.querySelector('#mlv-fs-img');
  const btnPrev = wrap.querySelector('#mlv-fs-prev');
  const btnNext = wrap.querySelector('#mlv-fs-next');
  let scale = 1;
  let tx = 0;
  let ty = 0;
  let startX = 0;
  let startY = 0;
  let drag = false;
  let pinch = false;
  let startDist = 0;
  let startScale = 1;
  let lastTapTs = 0;

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }
  function dist(t1, t2) {
    const dx = t1.clientX - t2.clientX;
    const dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
  function renderTransform() {
    if (img) img.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
  }
  function resetTransform() {
    scale = 1;
    tx = 0;
    ty = 0;
    renderTransform();
  }
  function showSlide(i) {
    idx = ((i % list.length) + list.length) % list.length;
    resetTransform();
    if (img) img.src = list[idx];
  }
  function goPrev(e) {
    e?.stopPropagation?.();
    if (list.length < 2 || scale > 1) return;
    showSlide(idx - 1);
  }
  function goNext(e) {
    e?.stopPropagation?.();
    if (list.length < 2 || scale > 1) return;
    showSlide(idx + 1);
  }
  function close(fromPop = false) {
    if (closed) return;
    closed = true;
    document.removeEventListener('keydown', onKey);
    window.removeEventListener('popstate', onPopState);
    document.body.style.overflow = prevOverflow;
    wrap.remove();
    if (!fromPop && window.history.state?.__mlvImageFullscreen === true) {
      window.history.back();
    }
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
    if (scale === 1 && list.length > 1) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goPrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goNext();
      }
    }
  }
  function onPopState() {
    close(true);
  }
  wrap.addEventListener('click', (e) => {
    if (e.target === wrap) close();
  });
  wrap.querySelector('#mlv-fs-close')?.addEventListener('click', (ev) => {
    ev.stopPropagation();
    close();
  });
  btnPrev?.addEventListener('click', goPrev);
  btnNext?.addEventListener('click', goNext);
  stage?.addEventListener(
    'wheel',
    (e) => {
      e.preventDefault();
      const delta = e.deltaY < 0 ? 0.2 : -0.2;
      scale = clamp(scale + delta, 1, 5);
      if (scale === 1) {
        tx = 0;
        ty = 0;
      }
      renderTransform();
    },
    { passive: false }
  );
  stage?.addEventListener('touchstart', (e) => {
    if (e.touches.length === 2) {
      pinch = true;
      drag = false;
      startDist = dist(e.touches[0], e.touches[1]);
      startScale = scale;
      return;
    }
    if (e.touches.length === 1) {
      const now = Date.now();
      if (now - lastTapTs < 300) {
        if (scale === 1) {
          scale = 2;
        } else {
          resetTransform();
        }
        renderTransform();
      }
      lastTapTs = now;
      drag = true;
      pinch = false;
      startX = e.touches[0].clientX - tx;
      startY = e.touches[0].clientY - ty;
    }
  });
  stage?.addEventListener(
    'touchmove',
    (e) => {
      if (pinch && e.touches.length === 2) {
        e.preventDefault();
        const d = dist(e.touches[0], e.touches[1]);
        scale = clamp(startScale * (d / Math.max(1, startDist)), 1, 5);
        if (scale === 1) {
          tx = 0;
          ty = 0;
        }
        renderTransform();
        return;
      }
      if (drag && e.touches.length === 1 && scale > 1) {
        e.preventDefault();
        tx = e.touches[0].clientX - startX;
        ty = e.touches[0].clientY - startY;
        renderTransform();
      }
    },
    { passive: false }
  );
  stage?.addEventListener('touchend', () => {
    if (scale <= 1) resetTransform();
    drag = false;
    pinch = false;
  });
  window.history.pushState(
    { ...(window.history.state || {}), ...fsStateMarker },
    ''
  );
  window.addEventListener('popstate', onPopState);
  document.addEventListener('keydown', onKey);
  document.body.appendChild(wrap);
}

function esProductoPremium(it) {
  return Boolean(it?.negocio_premium === true);
}

/** Overlay "VENDIDO" solo mientras dure mostrar_badge_vendido_hasta. */
function badgeVendidoListadoActivo(it) {
  if (String(it?.estado || '') !== 'vendido') return false;
  const h = it.mostrar_badge_vendido_hasta;
  if (!h?.toMillis) return false;
  return Date.now() < h.toMillis();
}

/** En el catálogo no se abre detalle de ítems vendidos (quedan solo como referencia en el listado). */
function catalogoPermiteDetalleProducto(it) {
  return String(it?.estado || '') !== 'vendido';
}

export function createCatalogoPublicoPresenter({
  render,
  getFirebase,
  catalogoRepository,
  publicidadHomeRepository = null,
  perfilVentasRepository = null,
  loadUserProfileForWa = null,
  onBackToLogin,
  onSellProduct,
  onOpenProfile,
  onOpenProductoDetalle,
  onOpenPerfilVendedorUid,
  onOpenNotificacionesResena,
  onOpenServiciosBarrio,
  vendedorRepository = null,
  adminRepository = null,
}) {
  async function showCatalogoPublico({
    isAuthenticated = false,
    currentUser = null,
    syncResenaNotifBadges,
  } = {}) {
    mlvTrack(MLV_EVENTS.CATALOGO_VER, { authenticated: Boolean(isAuthenticated) });
    render(`
      <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
        <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/70 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
          <span class="h-10 w-10 shrink-0" aria-hidden="true"></span>
          ${mlvLogoAppBarCenter()}
          ${
            isAuthenticated
              ? `<button type="button" id="cat-notif" class="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Notificaciones">
              ${iconBellCat()}
              <span id="cat-notif-badge" class="pointer-events-none absolute right-1 top-1 min-h-[1.1rem] min-w-[1.1rem] rounded-full bg-red-600 px-1 text-center text-[10px] font-bold leading-tight text-white hidden"></span>
            </button>`
              : `<span class="h-10 w-10 shrink-0" aria-hidden="true"></span>`
          }
        </header>

        <main class="max-w-lg mx-auto px-4 pt-4">
          <div class="flex gap-2 mb-3">
            <div class="relative flex-1">
              <span class="pointer-events-none absolute left-3 top-1/2 z-[1] -translate-y-1/2">${iconSearchCat()}</span>
              <input id="filtro-texto" type="search" enterkeyhint="search" autocomplete="off" placeholder="Buscar productos o tiendas…" class="mlv-input-search w-full rounded-2xl border-0 bg-slate-200/60 py-3 pl-10 pr-3 text-sm text-slate-900 placeholder:text-slate-500 shadow-inner focus:outline-none focus:ring-2 focus:ring-brand-primary/25" />
            </div>
            <button type="button" id="cat-toggle-filtros" class="mlv-btn-filter flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-primary shadow-md transition hover:brightness-95" aria-expanded="false" aria-label="Más filtros">
              ${iconFilterCat()}
            </button>
          </div>

          <div id="cat-panel-extra" class="mb-4 hidden rounded-2xl border border-slate-200/80 bg-white/90 p-4 shadow-sm space-y-3">
            <p class="text-xs font-semibold uppercase tracking-wide text-slate-500">Filtros avanzados</p>
            <p class="text-[11px] text-slate-500 -mt-1">Estado, precios y categoría de acá se aplican cuando tocás <strong class="font-semibold text-slate-700">Aplicar filtros</strong>. La búsqueda y los chips de arriba siguen al instante.</p>
            <div>
              <label class="block text-xs font-medium text-slate-600 mb-1">Estado del producto</label>
              <select id="filtro-estado" class="w-full rounded-xl border-0 bg-slate-100 py-2.5 px-3 text-sm ring-1 ring-slate-200/80 focus:outline-none focus:ring-2 focus:ring-brand-primary/25">
                <option value="">Todos</option>
                <option value="nuevo">Nuevo</option>
                <option value="usado">Usado</option>
              </select>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <div>
                <label class="block text-xs font-medium text-slate-600 mb-1">Precio mín. (ARS)</label>
                <input id="filtro-min" type="text" inputmode="numeric" autocomplete="off" placeholder="0" class="w-full rounded-xl border-0 bg-slate-100 py-2 px-2 text-sm ring-1 ring-slate-200/80" />
              </div>
              <div>
                <label class="block text-xs font-medium text-slate-600 mb-1">Precio máx. (ARS)</label>
                <input id="filtro-max" type="text" inputmode="numeric" autocomplete="off" placeholder="${PRECIO_MAX_FILTRO_ARS}" class="w-full rounded-xl border-0 bg-slate-100 py-2 px-2 text-sm ring-1 ring-slate-200/80" />
              </div>
            </div>
            <p class="text-[11px] text-slate-400 -mt-1">Hasta $ ${formatPrecioAr(PRECIO_MAX_FILTRO_ARS)} por campo.</p>
            <div>
              <label class="block text-xs font-medium text-slate-600 mb-1">Categoría (filtro avanzado)</label>
              <select id="filtro-categoria-extra" class="w-full rounded-xl border-0 bg-slate-100 py-2.5 px-3 text-sm ring-1 ring-slate-200/80 focus:outline-none focus:ring-2 focus:ring-brand-primary/25">
                <option value="">Todas (o usá los filtros rápidos arriba)</option>
                ${CATEGORIAS_PRODUCTO.map(
                  (c) =>
                    `<option value="${esc(c.id)}">${esc(c.label)}</option>`
                ).join('')}
              </select>
            </div>
            <button type="button" id="cat-aplicar-filtros-avanzados" class="mlv-btn-primary w-full rounded-xl bg-brand-primary py-3 text-sm font-semibold text-white shadow-sm transition hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2">
              Aplicar filtros
            </button>
          </div>

          <select id="filtro-categoria" class="sr-only" aria-hidden="true" tabindex="-1">
            <option value="">Todas</option>
            ${CATEGORIAS_PRODUCTO.map(
              (c) => `<option value="${esc(c.id)}">${esc(c.label)}</option>`
            ).join('')}
          </select>

          <div class="mb-1">
            <p class="text-xs font-semibold uppercase tracking-wide text-slate-500">Filtros rápidos</p>
            <p class="text-[11px] text-slate-400 mt-0.5">Por categoría</p>
          </div>
          <div class="mb-5 flex items-center gap-1.5 sm:gap-2" role="region" aria-label="Categorías">
            <button type="button" id="cat-chips-prev" class="cat-carousel-arrow flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200/90 bg-white text-brand-primary shadow-sm transition hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-25 hidden" aria-label="Categorías anteriores">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>
            </button>
            <div class="min-w-0 flex-1 overflow-hidden">
              <div id="cat-chips" class="mlv-carousel-track flex snap-x snap-mandatory gap-2 overflow-x-auto scroll-smooth py-1">
              ${CHIPS_CATEGORIA.map(
                (ch) => `
              <button type="button" class="cat-chip mlv-chip-off shrink-0 snap-start rounded-full px-3.5 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm" data-chip-cat="${esc(ch.value)}">
                ${esc(ch.label)}
              </button>`
              ).join('')}
              </div>
            </div>
            <button type="button" id="cat-chips-next" class="cat-carousel-arrow flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200/90 bg-white text-brand-primary shadow-sm transition hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-25 hidden" aria-label="Categorías siguientes">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>
            </button>
          </div>

          <div id="cat-publicidad-wrap" class="mb-6 hidden space-y-5">
            <div id="cat-ad-negocio"></div>
            <div id="cat-ad-destacados"></div>
            <div id="cat-ad-comercios"></div>
          </div>

          <div class="mb-3 flex items-center justify-between">
            <h2 class="mlv-section-title font-heading text-lg font-bold text-slate-900">Para vos</h2>
            <button type="button" id="cat-ver-todo" class="text-sm font-semibold text-brand-primary hover:underline">Ver todo</button>
          </div>

          <p id="catalogo-msg" class="text-sm text-slate-600 mb-3 min-h-[1.25rem]">Cargando productos…</p>
          <ul id="catalogo-list" class="grid grid-cols-2 gap-3"></ul>
          <button type="button" id="cat-cargar-mas" class="mt-4 hidden w-full rounded-xl border border-slate-200 bg-white py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50">
            Cargar más publicaciones
          </button>
        </main>

        <nav class="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200/90 bg-white/95 px-2 pt-2 backdrop-blur-md" style="padding-bottom:max(0.75rem, env(safe-area-inset-bottom))">
          <div class="mx-auto flex max-w-lg items-center justify-around">
            <button type="button" id="cat-nav-explorar" class="mlv-nav-active flex flex-1 flex-col items-center gap-1 rounded-xl bg-brand-primary/10 py-2 text-brand-primary">
              ${iconNavHomeCat()}
              <span class="text-[10px] font-semibold">Explorar</span>
            </button>
            ${
              isServiciosNavVisible()
                ? `<button type="button" id="cat-nav-servicios" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${iconNavServiciosCat()}
              <span class="text-[10px] font-medium">Servicios</span>
            </button>`
                : ''
            }
            <button type="button" id="cat-nav-vender" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${iconNavPlusCat(false)}
              <span class="text-[10px] font-medium">Vender</span>
            </button>
            <button type="button" id="cat-nav-perfil" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${iconNavPersonCat()}
              <span class="text-[10px] font-medium">Mi perfil</span>
            </button>
          </div>
        </nav>
      </div>
    `);

    document.getElementById('cat-notif')?.addEventListener('click', () => {
      void onOpenNotificacionesResena?.();
    });
    syncResenaNotifBadges?.();

    function guestInviteModal() {
      openGuestAuthModal({
        onLogin: () => onBackToLogin?.(),
      });
    }

    const toggleFiltros = document.getElementById('cat-toggle-filtros');
    const panelExtra = document.getElementById('cat-panel-extra');
    if (toggleFiltros && panelExtra) {
      toggleFiltros.onclick = () => {
        panelExtra.classList.toggle('hidden');
        toggleFiltros.setAttribute(
          'aria-expanded',
          String(!panelExtra.classList.contains('hidden'))
        );
      };
    }

    document.getElementById('cat-nav-explorar').onclick = () => {};
    document.getElementById('cat-nav-servicios')?.addEventListener('click', () => {
      if (!isAuthenticated) guestInviteModal();
      else onOpenServiciosBarrio?.();
    });
    document.getElementById('cat-nav-vender').onclick = () => {
      if (isAuthenticated) onSellProduct?.();
      else guestInviteModal();
    };
    document.getElementById('cat-nav-perfil').onclick = () => {
      if (isAuthenticated) onOpenProfile?.();
      else guestInviteModal();
    };

    const filtroTexto = document.getElementById('filtro-texto');
    const filtroCategoria = document.getElementById('filtro-categoria');
    const filtroCategoriaExtra = document.getElementById('filtro-categoria-extra');
    const msg = document.getElementById('catalogo-msg');
    const list = document.getElementById('catalogo-list');
    const filtroEstado = document.getElementById('filtro-estado');
    const filtroMin = document.getElementById('filtro-min');
    const filtroMax = document.getElementById('filtro-max');
    const btnAplicarAvanzados = document.getElementById('cat-aplicar-filtros-avanzados');
    const btnCargarMas = document.getElementById('cat-cargar-mas');
    const chipsTrack = document.getElementById('cat-chips');
    const chipsPrev = document.getElementById('cat-chips-prev');
    const chipsNext = document.getElementById('cat-chips-next');
    function updateChipsCarouselButtons() {
      if (!chipsTrack || !chipsPrev || !chipsNext) return;
      const max = Math.max(0, chipsTrack.scrollWidth - chipsTrack.clientWidth);
      const needsScroll = max > 4;
      chipsPrev.classList.toggle('hidden', !needsScroll);
      chipsNext.classList.toggle('hidden', !needsScroll);
      if (!needsScroll) {
        chipsPrev.disabled = true;
        chipsNext.disabled = true;
        return;
      }
      const sl = chipsTrack.scrollLeft;
      chipsPrev.disabled = sl <= 1;
      chipsNext.disabled = sl >= max - 1;
    }
    function scrollChipsCarousel(dir) {
      if (!chipsTrack) return;
      const step = Math.max(160, Math.floor(chipsTrack.clientWidth * 0.72));
      chipsTrack.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    if (chipsPrev && chipsNext && chipsTrack) {
      chipsPrev.onclick = () => scrollChipsCarousel(-1);
      chipsNext.onclick = () => scrollChipsCarousel(1);
      chipsTrack.addEventListener('scroll', updateChipsCarouselButtons, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => updateChipsCarouselButtons());
        ro.observe(chipsTrack);
      }
      requestAnimationFrame(updateChipsCarouselButtons);
    }

    function clampInputPrecioEntero(el) {
      if (!el) return;
      const maxDigits = String(PRECIO_MAX_FILTRO_ARS).length;
      el.addEventListener('input', () => {
        const digits = String(el.value || '')
          .replace(/\D/g, '')
          .slice(0, maxDigits);
        if (digits === '') {
          el.value = '';
          return;
        }
        let n = parseInt(digits, 10);
        if (!Number.isFinite(n) || n < 0) {
          el.value = '';
          return;
        }
        if (n > PRECIO_MAX_FILTRO_ARS) n = PRECIO_MAX_FILTRO_ARS;
        el.value = String(n);
      });
    }
    clampInputPrecioEntero(filtroMin);
    clampInputPrecioEntero(filtroMax);

    function syncChipsFromSelect() {
      const v = String(filtroCategoria.value || '');
      document.querySelectorAll('.cat-chip').forEach((btn) => {
        const isSel = btn.getAttribute('data-chip-cat') === v;
        btn.classList.toggle('mlv-chip-on', isSel);
        btn.classList.toggle('mlv-chip-off', !isSel);
        btn.classList.toggle('bg-brand-primary', isSel);
        btn.classList.toggle('text-white', isSel);
        btn.classList.toggle('bg-slate-200/80', !isSel);
        btn.classList.toggle('text-slate-700', !isSel);
      });
    }

    function ordenarParaCatalogo(items) {
      return [...items].sort((a, b) => {
        const pa = esProductoPremium(a) ? 1 : 0;
        const pb = esProductoPremium(b) ? 1 : 0;
        if (pa !== pb) return pb - pa;
        return 0;
      });
    }

    function renderListado(filtered, catalogoSinNada) {
      if (catalogoSinNada) {
        list.innerHTML = '';
        msg.classList.remove('hidden');
        msg.textContent =
          'Todavía no hay publicaciones en el barrio. Volvé pronto o animate a ser el primero en vender.';
        return;
      }
      if (!filtered.length) {
        list.innerHTML = '';
        msg.classList.remove('hidden');
        msg.textContent =
          'No encontramos nada con estos filtros. Probá otras palabras o sacá algún filtro.';
        return;
      }
      msg.textContent = '';
      msg.classList.add('hidden');
      const ordered = ordenarParaCatalogo(filtered);
      list.innerHTML = ordered
        .map((it) => {
          const fotos = Array.isArray(it.fotos) ? it.fotos : [];
          const imgUrl = fotos[0] || '';
          const catKey = it.categoria_id || 'general';
          const catUpper = (ETIQUETA_CATEGORIA_CARD[catKey] || ETIQUETA_CATEGORIA[catKey] || catKey).toUpperCase();
          const esNuevo = (it.estado_producto || 'usado') === 'nuevo';
          const badgeClass = esNuevo
            ? 'mlv-card-badge-nuevo bg-brand-secondary text-white'
            : 'bg-white/90 text-slate-700 ring-1 ring-slate-200/80';
          const badgeText = esNuevo ? 'Nuevo' : 'Usado';
          const premium = esProductoPremium(it);
          const repBadge = htmlBadgeEstrellasReputacion({
            promedio: Number(it.vendedor_reputacion_avg) || 0,
            cantidad: Number(it.vendedor_reputacion_cuenta) || 0,
          });
          const overlayVendido = badgeVendidoListadoActivo(it)
            ? `<div class="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/45">
                <span class="rounded-lg bg-white/95 px-3 py-1.5 text-sm font-black uppercase tracking-widest text-slate-900 shadow-lg">Vendido</span>
              </div>`
            : '';
          const vendidoSutil =
            String(it.estado || '') === 'vendido' && !badgeVendidoListadoActivo(it)
              ? `<p class="mt-1 text-[10px] font-semibold uppercase tracking-wide text-slate-400">Vendido</p>`
              : '';
          const puedeDetalle = catalogoPermiteDetalleProducto(it);
          const imgBlock = imgUrl
            ? `<img src="${esc(imgUrl)}" alt="" class="h-full w-full object-cover" loading="lazy" />`
            : `<div class="flex h-full w-full items-center justify-center bg-slate-200 text-slate-400 text-xs">Sin foto</div>`;
          return `
        <li>
          <button type="button" data-producto-id="${esc(it.id)}" data-detalle-ok="${puedeDetalle ? '1' : '0'}" class="group block w-full overflow-hidden rounded-2xl bg-white text-left shadow-[0_2px_10px_rgba(0,0,0,0.06)] ring-1 ring-slate-200/70 transition hover:shadow-[0_4px_16px_rgba(0,0,0,0.08)] ${puedeDetalle ? '' : 'cursor-default opacity-95'}" ${puedeDetalle ? '' : 'aria-disabled="true"'} title="${puedeDetalle ? '' : 'Vendido — sin detalle en el catálogo'}">
            <div class="relative aspect-square w-full overflow-hidden bg-slate-200">
              ${imgBlock}
              <span class="absolute left-2 top-2 rounded-md px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${badgeClass}">${badgeText}</span>
              ${
                premium
                  ? '<span class="absolute right-2 top-2 rounded-md bg-amber-500 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white shadow-sm">Premium</span>'
                  : ''
              }
              ${repBadge}
              ${overlayVendido}
            </div>
            <div class="px-3 pb-3 pt-2.5">
              <p class="mb-0.5 text-[10px] font-bold uppercase tracking-wide text-brand-tertiary">${esc(catUpper)}</p>
              <p class="line-clamp-2 text-sm font-bold leading-snug text-slate-900">${esc(it.titulo || 'Sin título')}</p>
              <p class="mt-1 text-base font-bold text-brand-tertiary">$ ${esc(formatPrecioAr(it.precio))}</p>
              ${vendidoSutil}
            </div>
          </button>
        </li>`;
        })
        .join('');
      list.querySelectorAll('[data-producto-id]').forEach((btn) => {
        btn.onclick = () => {
          if (btn.getAttribute('data-detalle-ok') !== '1') return;
          onOpenProductoDetalle?.(btn.getAttribute('data-producto-id'));
        };
      });
    }

    /** Valores del panel avanzado que ya aplicó el usuario (botón "Aplicar filtros") */
    let commitEstadoAvanzado = '';
    let commitMinPrecio = '';
    let commitMaxPrecio = '';

    let publicidadSlotsActivos = false;
    function filtrosCatalogoActivos() {
      return hayFiltrosCatalogoActivos({
        textoBusqueda: filtroTexto.value,
        categoriaId: filtroCategoria.value,
        estadoProducto: commitEstadoAvanzado,
        precioMinRaw: commitMinPrecio,
        precioMaxRaw: commitMaxPrecio,
        precioMaxCap: PRECIO_MAX_FILTRO_ARS,
      });
    }
    function syncPublicidadWrapCatalogo() {
      const wrap = document.getElementById('cat-publicidad-wrap');
      if (!wrap) return;
      wrap.classList.toggle('hidden', filtrosCatalogoActivos() || !publicidadSlotsActivos);
    }

    function aplicarFiltros(items) {
      const q = normalizarTextoBusquedaCatalogo(filtroTexto.value);
      const cat = String(filtroCategoria.value || '').trim();
      const estado = String(commitEstadoAvanzado || '').trim();
      let min = parsePrecioFiltroEnteroCatalogo(commitMinPrecio, PRECIO_MAX_FILTRO_ARS);
      let max = parsePrecioFiltroEnteroCatalogo(commitMaxPrecio, PRECIO_MAX_FILTRO_ARS);
      const ord = ordenarMinMaxFiltroPrecio(min, max);
      return filtrarProductosCatalogo(items, { q, cat, estado, min: ord.min, max: ord.max });
    }

    let refresh = () => {};
    const byId = new Map();
    let items = [];
    let nextCursor = null;
    let hasMore = true;
    let loadingPage = false;
    const PAGE_SIZE = 24;

    async function aplicarPublicidadHome(pubDoc) {
      const wrap = document.getElementById('cat-publicidad-wrap');
      const negEl = document.getElementById('cat-ad-negocio');
      const desEl = document.getElementById('cat-ad-destacados');
      const comEl = document.getElementById('cat-ad-comercios');
      if (!wrap || !negEl || !desEl || !comEl) return;
      let { negocio, destacadosItems, comercios } = slotsPublicidadHomeDesdeDoc(pubDoc);
      if (catalogoRepository?.filtrarDestacadosProductoAunPublicado) {
        try {
          destacadosItems = await catalogoRepository.filtrarDestacadosProductoAunPublicado(
            destacadosItems || []
          );
        } catch (_e) {
          /* si falla, se muestran slots sin este filtro */
        }
      }
      publicidadSlotsActivos =
        Boolean(negocio) ||
        (Array.isArray(destacadosItems) && destacadosItems.length > 0) ||
        (Array.isArray(comercios) && comercios.length > 0);

      // Foto del avatar del "Negocio del día" (Storage por UID; sin lookup DNI).
      let negocioFotoPerfilUrl = '';
      if (negocio && perfilVentasRepository?.obtenerUrlFotoPerfilPorUid) {
        const uidNeg = String(negocio.vendedor_uid || '').trim();
        if (/^[A-Za-z0-9_-]{10,128}$/.test(uidNeg)) {
          try {
            negocioFotoPerfilUrl =
              (await perfilVentasRepository.obtenerUrlFotoPerfilPorUid(uidNeg)) || '';
          } catch (_e) {
            negocioFotoPerfilUrl = '';
          }
        }
      }

      let comerciosRows = comercios || [];
      if (perfilVentasRepository?.obtenerUrlFotoPerfilPorUid && comerciosRows.length) {
        comerciosRows = await Promise.all(
          comerciosRows.map(async (row) => {
            const uidFinal = String(row?.vendedor_uid || '').trim();
            let foto = '';
            if (/^[A-Za-z0-9_-]{10,128}$/.test(uidFinal)) {
              try {
                foto = (await perfilVentasRepository.obtenerUrlFotoPerfilPorUid(uidFinal)) || '';
              } catch (_e) {
                foto = '';
              }
            }
            return { ...row, foto_perfil_url: foto };
          })
        );
      }

      pintarBloquesPublicidadHome({
        wrapEl: wrap,
        negocioEl: negEl,
        destacadosEl: desEl,
        comerciosEl: comEl,
        negocio,
        negocioFotoPerfilUrl,
        destacadosItems,
        comerciosRows,
        onOpenPerfilVendedorUid: (uid) => {
          if (!uid) return;
          onOpenPerfilVendedorUid?.(uid);
        },
        onOpenProductoDetalle: (id) => {
          if (!id) return;
          onOpenProductoDetalle?.(id);
        },
      });
      syncPublicidadWrapCatalogo();
    }

    function mergeItems(newItems) {
      for (const it of newItems) byId.set(it.id, it);
      items = [...byId.values()];
    }

    function syncCargarMas() {
      if (!btnCargarMas) return;
      btnCargarMas.classList.toggle('hidden', !hasMore);
      btnCargarMas.disabled = loadingPage;
      btnCargarMas.textContent = loadingPage
        ? 'Cargando…'
        : 'Cargar más publicaciones';
    }

    async function cargarPagina() {
      if (loadingPage || !hasMore) return;
      loadingPage = true;
      syncCargarMas();
      try {
        const page = await catalogoRepository.listarProductosParaCatalogoPage({
          isAuthenticated,
          pageSize: PAGE_SIZE,
          cursor: nextCursor,
        });
        mergeItems(page.items);
        nextCursor = page.nextCursor;
        hasMore = page.hasMore && Boolean(page.nextCursor);
        refresh();
      } finally {
        loadingPage = false;
        syncCargarMas();
      }
    }

    const publicidadPromise = publicidadHomeRepository
      ? publicidadHomeRepository.obtenerDocumentoActivo().catch(() => null)
      : Promise.resolve(null);

    try {
      syncChipsFromSelect();
      refresh = () => {
        const catalogoVacio = items.length === 0;
        renderListado(aplicarFiltros(items), catalogoVacio);
        syncPublicidadWrapCatalogo();
      };
      filtroTexto.oninput = refresh;
      filtroCategoria.onchange = () => {
        syncChipsFromSelect();
        refresh();
      };
      /* Estado, precios y categoría del panel avanzado: solo al pulsar "Aplicar filtros" */

      document.querySelectorAll('.cat-chip').forEach((btn) => {
        btn.onclick = () => {
          filtroCategoria.value = btn.getAttribute('data-chip-cat') || '';
          if (filtroCategoriaExtra) filtroCategoriaExtra.value = filtroCategoria.value;
          syncChipsFromSelect();
          refresh();
        };
      });

      function aplicarFiltrosAvanzadosUI() {
        commitEstadoAvanzado = String(filtroEstado?.value || '');
        commitMinPrecio = String(filtroMin?.value || '');
        commitMaxPrecio = String(filtroMax?.value || '');
        if (filtroCategoriaExtra) {
          filtroCategoria.value = filtroCategoriaExtra.value;
          syncChipsFromSelect();
        }
        refresh();
        if (panelExtra) panelExtra.classList.add('hidden');
        if (toggleFiltros) toggleFiltros.setAttribute('aria-expanded', 'false');
      }

      if (btnAplicarAvanzados) {
        btnAplicarAvanzados.onclick = () => aplicarFiltrosAvanzadosUI();
      }

      if (btnCargarMas) {
        btnCargarMas.onclick = () => {
          void cargarPagina();
        };
      }

      document.getElementById('cat-ver-todo').onclick = () => {
        filtroTexto.value = '';
        filtroCategoria.value = '';
        filtroEstado.value = '';
        filtroMin.value = '';
        filtroMax.value = '';
        commitEstadoAvanzado = '';
        commitMinPrecio = '';
        commitMaxPrecio = '';
        if (filtroCategoriaExtra) filtroCategoriaExtra.value = '';
        syncChipsFromSelect();
        refresh();
      };

      await cargarPagina();
      const pubDoc = await publicidadPromise;
      await aplicarPublicidadHome(pubDoc);
    } catch (err) {
      console.error(err);
      msg.classList.remove('text-slate-600');
      msg.classList.add('text-red-700');
      msg.textContent =
        'No pudimos cargar el catálogo. Revisá tu conexión y probá de nuevo. Si sigue fallando, escribinos.';
    }
  }

  async function showProductoDetalle(
    productId,
    {
      isAuthenticated = false,
      onBack,
      onOpenProfile,
      onSellProduct,
      onBackToLogin,
      onVerPlanPremium,
      onOpenPerfilVendedorUid,
    } = {}
  ) {
    if (!productId) {
      onBack?.();
      return;
    }

    mlvTrack(MLV_EVENTS.PRODUCTO_VER, {
      id: String(productId),
      authenticated: Boolean(isAuthenticated),
    });

    const currentUser = getFirebase ? getFirebase().auth.currentUser : null;

    render(`
      <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
        <p class="px-4 py-8 text-center text-slate-600">Cargando publicación…</p>
      </div>
    `);

    try {
      const p = await catalogoRepository.obtenerProductoPorId(productId);
      if (!p) {
        render(`
          <div class="min-h-screen bg-brand-surface mlv-bg-surface px-4 py-8">
            <p class="text-red-700 text-sm mb-4">No se encontró esta publicación.</p>
            <button type="button" id="btn-volver-det" class="rounded-full bg-brand-primary px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-primary/90">Volver al catálogo</button>
          </div>
        `);
        document.getElementById('btn-volver-det').onclick = () => onBack?.();
        return;
      }
      if (p.estado === 'vendido') {
        const premiumId = typeof onVerPlanPremium === 'function' ? 'btn-premium-vendido' : '';
        const footVitrina =
          p.listado_catalogo_vendido === true
            ? '<p class="mt-4 text-center text-[11px] leading-snug text-slate-500">El link puede seguir circulando; en el catálogo el aviso a veces queda solo como referencia de la venta.</p>'
            : '';
        render(`
          <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-10">
            <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
              <button type="button" id="det-vendido-back" class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Volver">
                ${iconBackHeaderTealDet()}
              </button>
              <h1 class="mlv-screen-title flex-1 text-center font-heading text-lg font-bold tracking-tight text-brand-primary">Publicación</h1>
              <div class="h-10 w-10 shrink-0" aria-hidden="true"></div>
            </header>
            <main class="mx-auto max-w-lg px-4 pt-8">
              <div class="rounded-3xl border border-slate-200/90 bg-white p-6 shadow-sm ring-1 ring-slate-100">
                ${htmlVendidoUpsellBlock({
                  premiumBtnId: premiumId,
                  catalogBtnId: 'btn-catalogo-vendido',
                  footnote: footVitrina,
                })}
              </div>
            </main>
          </div>
        `);
        document.getElementById('det-vendido-back')?.addEventListener('click', () => onBack?.());
        document.getElementById('btn-catalogo-vendido')?.addEventListener('click', () => onBack?.());
        document.getElementById('btn-premium-vendido')?.addEventListener('click', () => onVerPlanPremium?.());
        return;
      }
      if (!isAuthenticated && p.estado !== 'publicado') {
        render(`
          <div class="min-h-screen bg-brand-surface mlv-bg-surface px-4 py-8">
            <p class="text-red-700 text-sm mb-4">Esta publicación no está disponible.</p>
            <button type="button" id="btn-volver-det" class="rounded-full bg-brand-primary px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-primary/90">Volver al catálogo</button>
          </div>
        `);
        document.getElementById('btn-volver-det').onclick = () => onBack?.();
        return;
      }

      let relacionados = [];
      try {
        relacionados = await catalogoRepository.listarMasProductosParaDetalle({
          excludeId: p.id,
          categoriaId: p.categoria_id || 'general',
          max: 12,
        });
      } catch (e) {
        console.error(e);
      }

      const catKey = p.categoria_id || 'general';
      const catTag = String(
        ETIQUETA_CATEGORIA_CARD[catKey] || ETIQUETA_CATEGORIA[catKey] || catKey
      ).toUpperCase();
      const esNuevo = (p.estado_producto || 'usado') === 'nuevo';
      const tagEstado = esNuevo ? 'Nuevo' : 'Usado';
      const premium = esProductoPremium(p);
      const fotos = Array.isArray(p.fotos) ? p.fotos : [];
      const fotosLimpias = fotos.map((u) => String(u || '').trim()).filter(Boolean);
      const imgHero = fotos[0] || '';
      const titulo = p.titulo || 'Sin título';
      const precioMostrar = p.precio;
      const precioFmt = formatPrecioAr(precioMostrar);
      const telefono = String(p.telefono_contacto || '').trim();
      const linkProducto = buildMlvProductPublicUrl(p.id);
      let nombreComprador =
        String(currentUser?.displayName || '').trim() ||
        String(currentUser?.email || '').split('@')[0] ||
        'Usuario';
      let codigoComprador = '';
      if (isAuthenticated && currentUser && typeof loadUserProfileForWa === 'function') {
        try {
          const pr = await loadUserProfileForWa(currentUser.uid);
          const n = String(pr?.nombre || '').trim();
          if (n) nombreComprador = n;
          codigoComprador = String(pr?.user_tag || '').trim();
        } catch (_e) {
          /* fallback arriba */
        }
      }
      const msgWhatsApp = isAuthenticated
        ? codigoComprador
          ? `Hola, soy ${nombreComprador}. Mi código de comprador es *${codigoComprador}*. Me interesa este producto.\n${linkProducto}`
          : `Hola, soy ${nombreComprador}. Me interesa este producto.\n${linkProducto}\n\n(Abrí «Mi perfil» en la app: al sincronizar se genera tu código de comprador de 4 caracteres para que el vendedor registre la venta.)`
        : `Hola, me interesa este producto.\n${linkProducto}\n\n(Si tenés cuenta en La Victoria Market, iniciá sesión y tocá de nuevo WhatsApp: el mensaje va a incluir tu código corto para el vendedor.)`;
      const waUrl = !telefono ? '' : buildWhatsAppUrl(telefono, msgWhatsApp);
      const repDetalle = htmlFilaEstrellasReputacionDetalle({
        promedio: Number(p.vendedor_reputacion_avg) || 0,
        cantidad: Number(p.vendedor_reputacion_cuenta) || 0,
      });
      const vendedorUidProd = String(p.vendedor_uid || '').trim();
      const puedeVerPerfil = /^[A-Za-z0-9_-]{10,128}$/.test(vendedorUidProd);

      let esAdminUi = false;
      if (currentUser) {
        esAdminUi = await resolverEsAdminSesion(getFirebase);
      }
      const uidSesion = String(currentUser?.uid || '').trim();
      const esPropietarioProducto = Boolean(
        uidSesion && vendedorUidProd && uidSesion === vendedorUidProd
      );
      const puedeMarcarVendido = esPropietarioProducto && p.estado === 'publicado';
      const puedeAdminBorrar = esAdminUi && p.estado === 'publicado';

      const detalleOpts = {
        isAuthenticated,
        onBack,
        onOpenProfile,
        onSellProduct,
        onBackToLogin,
        onVerPlanPremium,
        onOpenPerfilVendedorUid,
      };

      const galeriaExtra =
        fotos.length > 1
          ? `<div class="mt-3 flex gap-2 overflow-x-auto pb-1">${fotos
              .slice(1, 5)
              .map(
                (url, j) =>
                  `<img src="${esc(url)}" alt="" data-det-zoom-idx="${j + 1}" class="h-16 w-16 shrink-0 cursor-zoom-in rounded-lg object-cover ring-1 ring-slate-200" loading="lazy" />`
              )
              .join('')}</div>`
          : '';

      const relatedHtml =
        relacionados.length > 0
          ? `<section class="mt-8 border-t border-slate-200/80 px-4 pb-4 pt-6">
          <h3 class="mlv-section-title mb-1 text-base font-bold text-slate-900">Más productos</h3>
          <p class="mb-3 text-xs leading-relaxed text-slate-500">Priorizamos <strong class="font-semibold text-slate-700">Negocio Premium</strong> y la categoría <strong class="font-semibold text-slate-700">${esc(catTag)}</strong>. Tocá para abrir cada publicación.</p>
          <div class="grid grid-cols-2 gap-3">
            ${relacionados
              .map((it) => {
                const fu = Array.isArray(it.fotos) && it.fotos[0] ? it.fotos[0] : '';
                const img = fu
                  ? `<img src="${esc(fu)}" alt="" class="h-full w-full object-cover" loading="lazy" />`
                  : `<div class="flex h-full w-full items-center justify-center bg-slate-200 text-xs text-slate-500">Sin foto</div>`;
                const prem = esProductoPremium(it);
                const premHtml = prem
                  ? `<span class="absolute right-2 top-2 rounded-md bg-amber-500 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white shadow-sm">Premium</span>`
                  : '';
                return `<button type="button" class="det-rel-card block w-full overflow-hidden rounded-2xl bg-white text-left shadow-[0_2px_10px_rgba(0,0,0,0.06)] ring-1 ring-slate-200/70 transition hover:shadow-[0_4px_16px_rgba(0,0,0,0.08)]" data-det-rel-id="${esc(it.id)}" aria-label="Ver publicación: ${esc(it.titulo || 'producto')}">
                  <div class="relative aspect-square w-full overflow-hidden bg-slate-200">
                    ${img}
                    ${premHtml}
                  </div>
                  <div class="px-3 pb-3 pt-2.5">
                    <p class="line-clamp-2 text-sm font-bold text-slate-900">${esc(it.titulo || '')}</p>
                    <p class="mt-1 font-bold text-brand-tertiary">$ ${esc(formatPrecioAr(it.precio))}</p>
                  </div>
                </button>`;
              })
              .join('')}
          </div>
        </section>`
          : '';

      render(`
        <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
          <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/70 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
            <span class="h-10 w-10 shrink-0" aria-hidden="true"></span>
            ${mlvLogoAppBarCenter()}
            <span class="h-10 w-10 shrink-0" aria-hidden="true"></span>
          </header>

          <div class="relative -mb-10 w-full">
            ${
              imgHero
                ? `<img src="${esc(imgHero)}" alt="" data-det-zoom-idx="0" class="h-72 w-full cursor-zoom-in object-cover sm:h-80" />`
                : `<div class="flex h-72 w-full items-center justify-center bg-slate-300 text-slate-500">Sin foto</div>`
            }
            <button type="button" id="det-back-hero" class="absolute left-3 top-3 flex h-10 w-10 items-center justify-center rounded-full bg-white/95 shadow-md ring-1 ring-slate-200/80" aria-label="Volver">
              ${iconBackOnImageDet()}
            </button>
          </div>

          <div class="relative z-10 rounded-t-[32px] bg-white px-4 pb-6 pt-6 shadow-[0_-10px_28px_rgba(0,0,0,0.08)]">
            <div class="mb-3 flex flex-wrap gap-2">
              <span class="rounded-full bg-brand-tertiary px-3 py-1 text-xs font-bold uppercase tracking-wide text-white">${esc(catTag)}</span>
              <span class="rounded-full bg-slate-200/90 px-3 py-1 text-xs font-semibold text-slate-700">${esc(tagEstado)}</span>
              ${
                premium
                  ? '<span class="rounded-full bg-amber-500 px-3 py-1 text-xs font-bold uppercase tracking-wide text-white">Negocio Premium</span>'
                  : ''
              }
            </div>
            <h2 class="mlv-section-title font-heading text-xl font-bold leading-snug text-slate-900 sm:text-2xl">${esc(titulo)}</h2>
            <p class="mt-2 text-2xl font-bold text-brand-tertiary">$ ${esc(precioFmt)}</p>
            ${galeriaExtra}
            <section class="mt-6">
              <h3 class="mb-2 text-sm font-semibold font-heading text-slate-800">Descripción</h3>
              <p class="whitespace-pre-wrap text-sm leading-relaxed text-slate-700">${esc(p.descripcion || '')}</p>
            </section>

            <div class="mt-6 flex items-center gap-3 rounded-2xl bg-brand-muted/60 px-4 py-3 ring-1 ring-brand-primary/10">
              <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-secondary shadow-sm">
                ${iconStoreSellerDet()}
              </div>
              <div class="min-w-0 flex-1">
                <p class="font-bold text-slate-900">Vendedor verificado</p>
                <p class="text-xs text-slate-600">La Victoria Market · mismo barrio</p>
                ${repDetalle}
              </div>
              <span class="shrink-0" aria-hidden="true">${iconVerifiedBadgeDet()}</span>
            </div>

            ${
              puedeVerPerfil
                ? `<div class="mt-4">
              <button type="button" id="det-ver-perfil-vendedor" class="w-full rounded-xl border-2 border-brand-primary/40 bg-white py-3.5 text-sm font-bold text-brand-primary shadow-sm transition hover:bg-brand-primary/5">
                Ver perfil del vendedor
              </button>
            </div>`
                : ''
            }

            <div class="mt-6 space-y-3">
              ${
                waUrl
                  ? `<a id="det-wa-link" href="${esc(waUrl)}" target="_blank" rel="noopener noreferrer" class="flex w-full items-center justify-center gap-2 rounded-full bg-brand-secondary py-3.5 text-base font-bold text-white shadow-lg transition hover:bg-brand-secondary/90">
                      ${iconChatWaDet()}
                      Contactar por WhatsApp
                    </a>`
                  : `<p class="text-center text-sm text-slate-500">El vendedor no dejó un teléfono en esta publicación.</p>`
              }
              ${
                puedeMarcarVendido
                  ? `<button type="button" id="det-marcar-vendido" class="w-full rounded-full bg-brand-primary py-3.5 text-base font-bold text-white shadow-md transition hover:brightness-105">¡Lo vendí!</button>`
                  : ''
              }
              ${
                puedeAdminBorrar
                  ? `<button type="button" id="det-admin-borrar" class="w-full rounded-full border-2 border-red-300 bg-white py-3.5 text-base font-semibold text-red-700 hover:bg-red-50">Borrar publicación</button>`
                  : ''
              }
              <button type="button" id="det-volver-catalogo" class="w-full rounded-full border-2 border-slate-200 bg-white py-3.5 text-base font-semibold text-slate-800 hover:bg-slate-50">
                Volver al catálogo
              </button>
            </div>
          </div>

          ${relatedHtml}

          <nav class="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200/90 bg-white/95 px-2 pt-2 backdrop-blur-md" style="padding-bottom:max(0.75rem, env(safe-area-inset-bottom))">
            <div class="mx-auto flex max-w-lg items-center justify-around">
              <button type="button" id="det-nav-explorar" class="mlv-nav-active flex flex-1 flex-col items-center gap-1 rounded-xl bg-brand-primary/10 py-2 text-brand-primary">
                ${iconNavHomeCat()}
                <span class="text-[10px] font-semibold">Explorar</span>
              </button>
              ${
                isServiciosNavVisible()
                  ? `<button type="button" id="det-nav-servicios" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
                ${iconNavServiciosCat()}
                <span class="text-[10px] font-medium">Servicios</span>
              </button>`
                  : ''
              }
              <button type="button" id="det-nav-vender" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
                ${iconNavPlusCat(false)}
                <span class="text-[10px] font-medium">Vender</span>
              </button>
              <button type="button" id="det-nav-perfil" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
                ${iconNavPersonCat()}
                <span class="text-[10px] font-medium">Mi perfil</span>
              </button>
            </div>
          </nav>
        </div>
      `);

      function guestInviteModalDet() {
        openGuestAuthModal({
          onLogin: () => onBackToLogin?.(),
        });
      }

      function wireDetalle() {
        document.getElementById('det-back-hero').onclick = () => onBack?.();
        document.getElementById('det-volver-catalogo')?.addEventListener('click', () => onBack?.());
        document.getElementById('det-wa-link')?.addEventListener('click', () => {
          mlvTrack(MLV_EVENTS.PRODUCTO_CONTACTO_WA, {
            id: String(productId),
            authenticated: Boolean(isAuthenticated),
            categoria_id: String(p.categoria_id || 'general'),
          });
        });
        document.getElementById('det-marcar-vendido')?.addEventListener('click', async (e) => {
          const btn = e.currentTarget;
          if (!puedeMarcarVendido || !vendedorRepository) return;
          const u = String(getFirebase()?.auth?.currentUser?.uid || '').trim();
          if (!u || u !== vendedorUidProd) return;
          await runCompletarVentaFlow({
            getFirebase,
            repo: vendedorRepository,
            uid: u,
            productId: String(productId),
            sourceBtn: btn,
            trackOrigen: 'detalle',
            onSuccess: async () => {
              catalogoRepository?.invalidateCatalogoCache?.();
              await showProductoDetalle(productId, detalleOpts);
            },
            onError: (err) => {
              console.error(err);
              window.alert(err?.message || 'No se pudo marcar como vendida.');
            },
          });
        });
        document.getElementById('det-admin-borrar')?.addEventListener('click', async () => {
          if (!puedeAdminBorrar || !adminRepository) return;
          const u = getFirebase()?.auth?.currentUser;
          if (!u) return;
          const claimOk = await asegurarClaimAdminParaAccion(getFirebase);
          if (!claimOk) {
            window.alert(
              'Tu sesión de moderación no está activa. Cerrá sesión, volvé a entrar con el email admin y probá de nuevo.'
            );
            return;
          }
          const motivo = await openAdminEliminarPublicacionModal({ tituloProducto: titulo });
          if (!motivo) return;
          const btn = document.getElementById('det-admin-borrar');
          await withBusyButton(btn, async () => {
            await adminRepository.eliminarPublicacionModeracion(productId, motivo);
            catalogoRepository?.invalidateCatalogoCache?.();
            mlvTrack(MLV_EVENTS.PUBLICACION_ELIMINADA, { origen: 'admin_moderacion' });
            onBack?.();
          }, { labelBusy: 'Borrando…' });
        });
        if (puedeVerPerfil) {
          document.getElementById('det-ver-perfil-vendedor')?.addEventListener('click', () => {
            mlvTrack(MLV_EVENTS.PERFIL_VENDEDOR_VER, { origen: 'detalle' });
            onOpenPerfilVendedorUid?.(vendedorUidProd);
          });
        }
        document.getElementById('det-nav-explorar').onclick = () => onBack?.();
        document.getElementById('det-nav-servicios')?.addEventListener('click', () => {
          if (!isAuthenticated) guestInviteModalDet();
          else onOpenServiciosBarrio?.();
        });
        document.getElementById('det-nav-vender').onclick = () => {
          if (isAuthenticated) onSellProduct?.();
          else guestInviteModalDet();
        };
        document.getElementById('det-nav-perfil').onclick = () => {
          if (isAuthenticated) onOpenProfile?.();
          else guestInviteModalDet();
        };
        document.querySelectorAll('.det-rel-card').forEach((el) => {
          el.onclick = () => {
            const id = el.getAttribute('data-det-rel-id');
            if (id) onOpenProductoDetalle?.(id);
          };
        });
        if (fotosLimpias.length) {
          document.querySelectorAll('[data-det-zoom-idx]').forEach((el) => {
            el.addEventListener('click', () => {
              const i = Number(el.getAttribute('data-det-zoom-idx') || 0);
              openImageFullscreen(fotosLimpias, i);
            });
          });
        }
      }
      wireDetalle();
    } catch (err) {
      console.error(err);
      render(`
        <div class="min-h-screen bg-brand-surface mlv-bg-surface px-4 py-8">
          <p class="text-red-700 text-sm mb-2">No se pudo cargar el detalle.</p>
          <p class="text-xs text-slate-500 mb-4">${esc(err?.code || err?.message || '')}</p>
          <button type="button" id="btn-volver-det" class="rounded-full bg-brand-primary px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-primary/90">Volver al catálogo</button>
        </div>
      `);
      document.getElementById('btn-volver-det').onclick = () => onBack?.();
    }
  }

  return { showCatalogoPublico, showProductoDetalle };
}
